import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import ProductCard from "./ProductCard";
import LoadingSpinner from "./components/LoadingSpinner";
import "./App.css";
import { getOrFetch } from "./utils/apiCache";

function LatestPage() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const data = await getOrFetch(
          "latest:per_page:100",
          () =>
            axios
              .get("https://floriakw.com/wp-json/wc/v3/products", {
                auth: {
                  username: "ck_39cd5450af63b97a35e502d9a0a75925866fefab",
                  password: "cs_15701bd9b4392a3b6e5a3d5fa4d326d7acb0a0bf",
                },
                params: {
                  orderby: "date",
                  order: "desc",
                  per_page: 100,
                  status: "publish",
                },
              })
              .then((r) => r.data),
          { ttlMs: 10 * 60 * 1000 }
        );
        setProducts(data);
      } catch (err) {
        console.error("Latest full error:", err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="category-page">
      <div className="container">
        {/* Breadcrumb */}
        <nav className="breadcrumb">
          <Link to="/">الرئيسية</Link> / <span>الأحدث وصولا</span>
        </nav>

        {loading ? (
          <div className="loading-container">
            <LoadingSpinner size="medium" color="black" withText={true} />
          </div>
        ) : products.length === 0 ? (
          <p>لا توجد منتجات.</p>
        ) : (
          <>
            <p className="results-count">عرض {products.length} من كل النتائج</p>
            <div className="grid category-products">
              {products.map((p) => (
                <ProductCard key={p.id} product={p} />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default LatestPage;
